export const isArray = (val: any): boolean =>
  val != null &&
  val.length >= 0 &&
  Object.prototype.toString.call(val) === '[object Array]'
